// eslint-disable-next-line boundaries/no-unknown-files
import { createApi } from '@reduxjs/toolkit/query/react';
// eslint-disable-next-line boundaries/element-types
import reducerPath from "../../../../app/reducerPath";
// eslint-disable-next-line boundaries/element-types
import createHeadRequest from "../../../../shared/http/createHeadRequest";
// eslint-disable-next-line boundaries/element-types
import checkStatus from "../../../../shared/http/checkStatus";
// eslint-disable-next-line boundaries/element-types
import HttpMethods from "../../../../shared/api/HttpMethods";
// eslint-disable-next-line import/no-named-as-default
import sensorsResourceFromDtoService from "../services/data/sensorsResource-from-dto.service";
// eslint-disable-next-line boundaries/element-types
// eslint-disable-next-line boundaries/element-types
import baseQueryWithReAuth from "../../../baseQueryWithReAuth/baseQueryWithReAuth";
import config from '../../../../shared/api/config';

// Описываем методы обращения к беку
export const sensorsResourceApi = createApi({
  reducerPath: `${reducerPath.sensorResource}/api`,
  tagTypes: ['TAG'],
  baseQuery: (...arg) => baseQueryWithReAuth(...arg, `${config.baseUrl}/sensors`),
  endpoints: (builder) => ({
    putSensor: builder.mutation({
      query: ({
        id, body
      }) => ({
        ...createHeadRequest({
          url: `/${id}`, method: HttpMethods.PUT
        }),
        body,
        validateStatus: checkStatus,
      }),
      transformResponse: sensorsResourceFromDtoService
    }),
    patchSensor: builder.mutation({
      query: ({
        id, body
      }) => ({
        ...createHeadRequest({
          url: `/${id}`, method: HttpMethods.PUT,
        }),
        body,
        validateStatus: checkStatus,
      }),
      invalidatesTags: ['TAG'],
      transformResponse: sensorsResourceFromDtoService
    }),
    getSensors: builder.query({
      query: ({
        params
      }) => ({
        ...createHeadRequest({
          url: ``, method: HttpMethods.GET
        }),
        validateStatus: checkStatus,
        params
      }),
      providesTags: ['TAG'],
      transformResponse: sensorsResourceFromDtoService
    }),
    postSensor: builder.mutation({
      query: ({
        body
      }) => ({
        ...createHeadRequest({
          url: ``, method: HttpMethods.POST
        }),
        body,
        validateStatus: checkStatus,
      }),
      invalidatesTags: ['TAG'],
      transformResponse: sensorsResourceFromDtoService
    }),
    getSensor: builder.mutation({
      query: ({
        id, params
      }) => ({
        ...createHeadRequest({
          url: `/${id}`, method: HttpMethods.GET
        }),
        params,
        validateStatus: checkStatus,
      }),
      transformResponse: sensorsResourceFromDtoService
    }),
    deleteSensor: builder.mutation({
      query: ({
        id
      }) => ({
        ...createHeadRequest({
          url: `/${id}`, method: HttpMethods.DELETE
        }),
        validateStatus: checkStatus,
      }),
      invalidatesTags: ['TAG'],
      transformResponse: sensorsResourceFromDtoService
    }),
    getSensorsCount: builder.mutation({
      query: ({
        params
      }) => ({
        ...createHeadRequest({
          url: `/count`, method: HttpMethods.GET
        }),
        validateStatus: checkStatus,
        params
      }),
      transformResponse: sensorsResourceFromDtoService
    }),
  }),
});

export const {
  useGetSensorsQuery,
  useGetSensorMutation,
  useDeleteSensorMutation,
  useGetSensorsCountMutation,
  usePostSensorMutation,
  usePatchSensorMutation,
  usePutSensorMutation,

} = sensorsResourceApi;
